export default {
    AF: ['Afghanistan'],
    AX: ['Åland Islands'],
    AL: ['Albania'],
    DZ: ['Algeria'],
    AS: ['American Samoa'],
    AD: ['Andorra'],
    AO: ['Angola'],
    AI: ['Anguilla'],
    AQ: ['Antarctica'],
    AG: ['Antigua and Barbuda'],
    AR: ['Argentina'],
    AM: ['Armenia'],
    AW: ['Aruba'],
    AU: ['Australia'],
    AT: ['Austria'],
    AZ: ['Azerbaijan'],
    BS: ['Bahamas'],
    BH: ['Bahrain'],
    BD: ['Bangladesh'],
    BB: ['Barbados'],
    BY: ['Belarus'],
    BE: ['Belgium'],
    BZ: ['Belize'],
    BJ: ['Benin'],
    BM: ['Bermuda'],
    BT: ['Bhutan'],
    BO: ['Bolivia (Plurinational State of)', 'Bolivia'],
    BQ: ['"Bonaire Sint Eustatius and Saba"'],
    BA: ['Bosnia and Herzegovina'],
    BW: ['Botswana'],
    BV: ['Bouvet Island'],
    BR: ['Brazil'],
    IO: ['British Indian Ocean Territory'],
    BN: ['Brunei Darussalam'],
    BG: ['Bulgaria'],
    BF: ['Burkina Faso'],
    BI: ['Burundi'],
    CV: ['Cabo Verde', 'Cape Verde'],
    KH: ['Cambodia'],
    CM: ['Cameroon'],
    CA: ['Canada'],
    KY: ['Cayman Islands'],
    CF: ['Central African Republic'],
    TD: ['Chad'],
    CL: ['Chile'],
    CN: ['China'],
    CX: ['Christmas Island'],
    CC: ['Cocos (Keeling) Islands', 'Cocos (Keeling Islands)'],
    CO: ['Colombia'],
    KM: ['Comoros'],
    CG: ['Congo'],
    CD: ['Congo (Democratic Republic of the)', 'Zaire'],
    CK: ['Cook Islands'],
    CR: ['Costa Rica'],
    CI: ['C™te d\'Ivoire', 'Cote D\'Ivoire (Ivory Coast)'],
    HR: ['Croatia', 'Croatia (Hrvatska)'],
    CU: ['Cuba'],
    CW: ['Curaao'],
    CY: ['Cyprus'],
    CZ: ['Czechia', 'Czech Republic'],
    DK: ['Denmark'],
    DJ: ['Djibouti'],
    DM: ['Dominica'],
    DO: ['Dominican Republic'],
    EC: ['Ecuador'],
    EG: ['Egypt'],
    SV: ['El Salvador'],
    GQ: ['Equatorial Guinea'],
    ER: ['Eritrea'],
    EE: ['Estonia'],
    ET: ['Ethiopia'],
    FK: ['Falkland Islands (Malvinas)'],
    FO: ['Faroe Islands'],
    FJ: ['Fiji'],
    FI: ['Finland'],
    FR: ['France', 'France, Metropolitan'],
    GF: ['French Guiana'],
    PF: ['French Polynesia'],
    TF: ['French Southern Territories'],
    GA: ['Gabon'],
    GM: ['Gambia'],
    GE: ['Georgia'],
    DE: ['Germany'],
    GH: ['Ghana'],
    GI: ['Gibraltar'],
    GR: ['Greece'],
    GL: ['Greenland'],
    GD: ['Grenada'],
    GP: ['Guadeloupe'],
    GU: ['Guam'],
    GT: ['Guatemala'],
    GG: ['Guernsey'],
    GN: ['Guinea'],
    GW: ['Guinea-Bissau'],
    GY: ['Guyana'],
    HT: ['Haiti'],
    HM: ['Heard Island and McDonald Islands', 'Heard and McDonald Islands'],
    VA: ['Holy See', 'Vatican City State (Holy See)', 'Vatican City State', 'Vatican City'],
    HN: ['Honduras'],
    HK: ['Hong Kong'],
    HU: ['Hungary'],
    IS: ['Iceland'],
    IN: ['India'],
    ID: ['Indonesia'],
    IR: ['Iran (Islamic Republic of)', 'Iran'],
    IQ: ['Iraq'],
    IE: ['Ireland'],
    IM: ['Isle of Man'],
    IL: ['Israel'],
    IT: ['Italy'],
    JM: ['Jamaica'],
    JP: ['Japan'],
    JE: ['Jersey'],
    JO: ['Jordan'],
    KZ: ['Kazakhstan'],
    KE: ['Kenya'],
    KI: ['Kiribati'],
    KP: ['Korea (Democratic People\'s Republic of)', 'North Korea', 'Korea (North)'],
    KR: ['Korea (Republic of)', 'South Korea', 'Korea (South)'],
    KW: ['Kuwait'],
    KG: ['Kyrgyzstan'],
    LA: ['Lao People\'s Democratic Republic', 'Laos'],
    LV: ['Latvia'],
    LB: ['Lebanon'],
    LS: ['Lesotho'],
    LR: ['Liberia'],
    LY: ['Libya'],
    LI: ['Liechtenstein'],
    LT: ['Lithuania'],
    LU: ['Luxembourg'],
    MO: ['Macau', 'Macao'],
    MK: ['Macedonia (the former Yugoslav Republic of)', 'Macedonia'],
    MG: ['Madagascar'],
    MW: ['Malawi'],
    MY: ['Malaysia'],
    MV: ['Maldives'],
    ML: ['Mali'],
    MT: ['Malta'],
    MH: ['Marshall Islands'],
    MQ: ['Martinique'],
    MR: ['Mauritania'],
    MU: ['Mauritius'],
    YT: ['Mayotte'],
    MX: ['Mexico'],
    FM: ['Micronesia (Federated States of)', 'Micronesia'],
    MD: ['Moldova (Republic of)', 'Moldova'],
    MC: ['Monaco'],
    MN: ['Mongolia'],
    ME: ['Montenegro'],
    MS: ['Montserrat'],
    MA: ['Morocco'],
    MZ: ['Mozambique'],
    MM: ['Myanmar'],
    NA: ['Namibia'],
    NR: ['Nauru'],
    NP: ['Nepal'],
    NL: ['Netherlands'],
    NC: ['New Caledonia'],
    NZ: ['New Zealand'],
    NI: ['Nicaragua'],
    NE: ['Niger'],
    NG: ['Nigeria'],
    NU: ['Niue'],
    NF: ['Norfolk Island'],
    MP: ['Northern Mariana Islands'],
    NO: ['Norway'],
    OM: ['Oman'],
    PK: ['Pakistan'],
    PW: ['Palau'],
    PS: ['"Palestine State of"'],
    PA: ['Panama'],
    PG: ['Papua New Guinea'],
    PY: ['Paraguay'],
    PE: ['Peru'],
    PH: ['Philippines'],
    PN: ['Pitcairn'],
    PL: ['Poland'],
    PT: ['Portugal'],
    PR: ['Puerto Rico'],
    QA: ['Qatar'],
    RE: ['RŽunion', 'Reunion'],
    RO: ['Romania'],
    RU: ['Russian Federation'],
    RW: ['Rwanda'],
    BL: ['Saint BarthŽlemy'],
    SH: ['"Saint Helena Ascension and Tristan da Cunha"', 'St. Helena', 'Saint Helana'],
    KN: ['Saint Kitts and Nevis'],
    LC: ['Saint Lucia'],
    MF: ['Saint Martin (French part)'],
    PM: ['Saint Pierre and Miquelon', 'St. Pierre and Miquelon'],
    VC: ['Saint Vincent and the Grenadines', 'Saint Vincent and The Grenadines'],
    WS: ['Samoa'],
    SM: ['San Marino'],
    ST: ['Sao Tome and Principe'],
    SA: ['Saudi Arabia'],
    SN: ['Senegal'],
    RS: ['Serbia'],
    SC: ['Seychelles'],
    SL: ['Sierra Leone'],
    SG: ['Singapore'],
    SX: ['Sint Maarten (Dutch part)'],
    SK: ['Slovak Republic'],
    SI: ['Slovenia'],
    SB: ['Solomon Islands'],
    SO: ['Somalia'],
    ZA: ['South Africa'],
    GS: ['South Georgia and the South Sandwich Islands', 'S. Georgia and S. Sandwich Isls.'],
    SS: ['South Sudan'],
    ES: ['Spain'],
    LK: ['Sri Lanka'],
    SD: ['Sudan'],
    SR: ['Suriname'],
    SJ: ['Svalbard and Jan Mayen', 'Svalbard and Jan Mayen Islands'],
    SZ: ['Swaziland'],
    SE: ['Sweden'],
    CH: ['Switzerland'],
    SY: ['Syrian Arab Republic', 'Syria'],
    TW: ['"Taiwan Province of China[a]"', 'Taiwan'],
    TJ: ['Tajikistan'],
    TZ: ['"Tanzania United Republic of"', 'Tanzania'],
    TH: ['Thailand'],
    TL: ['Timor-Leste', 'East Timor'],
    TG: ['Togo'],
    TK: ['Tokelau'],
    TO: ['Tonga'],
    TT: ['Trinidad and Tobago'],
    TN: ['Tunisia'],
    TR: ['Turkey'],
    TM: ['Turkmenistan'],
    TC: ['Turks and Caicos Islands'],
    TV: ['Tuvalu'],
    UG: ['Uganda'],
    UA: ['Ukraine'],
    AE: ['United Arab Emirates'],
    GB: ['United Kingdom of Great Britain and Northern Ireland', 'United Kingdom'],
    US: ['United States of America', 'United States'],
    UM: ['United States Minor Outlying Islands', 'US Minor Outlying Islands'],
    UY: ['Uruguay'],
    UZ: ['Uzbekistan'],
    VU: ['Vanuatu'],
    VE: ['Venezuela (Bolivarian Republic of)', 'Venezuela'],
    VN: ['Viet Nam'],
    VG: ['Virgin Islands (British)'],
    VI: ['Virgin Islands (U.S.)', 'Virgin Islands (US)'],
    WF: ['Wallis and Futuna', 'Wallis and Futuna Islands'],
    EH: ['Western Sahara'],
    YE: ['Yemen'],
    ZM: ['Zambia'],
    ZW: ['Zimbabwe']
};
